var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom d-inline"},[_c('bee-label',{staticClass:"custom d-inline",attrs:{"bold":_vm.bold,"color":_vm.color,"empty-state":_vm.emptyState,"content":_vm.type ? _vm.getValueForType(_vm.type) : _vm.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }